import * as React from 'react';
/**
 *
 * Original name: video transition
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47294%3A3736
 *
 */
export const VideoTransitionFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M4 6.5h4.17c.252 0 .527.017.809.076h.002c.793.169 1.46.466 2.001.885L9.908 8.535c-.318-.21-.722-.381-1.238-.491A2.457 2.457 0 0 0 8.17 8H5.5v8h2.67c.187 0 .352-.013.5-.044.754-.16 1.265-.447 1.625-.806.557-.558.955-1.51.955-3.15l-.001-.143.002-.002c.023-1.79.476-3.147 1.394-4.065.6-.6 1.389-1.004 2.374-1.214h.002c.282-.059.557-.076.809-.076H20v11h-4.17c-.252 0-.527-.017-.809-.076h-.002c-.829-.177-1.521-.494-2.074-.943A4.056 4.056 0 0 1 12 15.367a4.056 4.056 0 0 1-.645.843c-.6.6-1.389 1.004-2.374 1.214h-.002a3.938 3.938 0 0 1-.809.076H4v-11Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
